import { render, staticRenderFns } from "./AssetRecordsTab.vue?vue&type=template&id=db08b7a8"
import script from "./AssetRecordsTab.vue?vue&type=script&lang=js"
export * from "./AssetRecordsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports